import _export from '../internals/export.js';
import toObject$1 from '../internals/to-object.js';
import objectKeys from '../internals/object-keys.js';
import fails$1 from '../internals/fails.js';

var $ = _export;
var toObject = toObject$1;
var nativeKeys = objectKeys;
var fails = fails$1;
var FAILS_ON_PRIMITIVES = fails(function () {
  nativeKeys(1);
}); // `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys

$({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES
}, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});
